import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import API_URL from "../config";
const Empwork = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const formattedToday = `${yyyy}-${mm}-${dd}`;
  const [codenum, setCode] = useState("");
  const [resultats, setResultats] = useState([]);
  const [datdu, setDatdu] = useState(formattedToday);
  const [datau, setDatau] = useState(formattedToday);
  const [totamount, setAmount] = useState("");
  const [tresseuseSearch, setTresseuseSearch] = useState([]);

  const [loading, setLoading] = useState(false);
  const [idTresseuse, setIdTresseuse] = useState(""); // ID réel
  const [error, setError] = useState(null); // ✅ gestion d'erreur

  const formatDollar = (amount) => {
    if (amount == null) return "$0.00"; // gestion des valeurs nulles
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const handleSearchwork = async () => {
    // alert(idTresseuse);
    if (!idTresseuse || !datdu || !datau) {
      setError("Veuillez remplir tous les champs !");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_URL}/tresseuse_work_report/`, {
        datdu,
        datau,
        idtres: idTresseuse, // ✅ on envoie l’ID
      });

      setResultats(res.data.resultats || []);
      setAmount(formatDollar(res.data.total_general_mtpaie));
      console.log(res.data);
    } catch (err) {
      console.error("Erreur récupération rapport:", err);
    }

    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (codenum.trim() === "") {
        setTresseuseSearch([]);
        return;
      }

      try {
        const res = await axios.post(`${API_URL}/search_tresseuse/`, {
          idtres: codenum,
        });
        setTresseuseSearch(res.data.data);
      } catch (error) {
        console.error("Erreur lors du chargement :", error);
      }
    };

    // petit délai (debounce) pour éviter trop de requêtes pendant la saisie
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [codenum]);

  // Quand l’utilisateur choisit une option
  const handleSelect = (e) => {
    const value = e.target.value; // ce que l’utilisateur a choisi

    const selected = tresseuseSearch.find(
      (tres) =>
        `${tres.nomtres}` === value ||
        `${tres.nomtres} (${tres.idtres})` === value,
    );

    if (selected) {
      setIdTresseuse(selected.idtres); // on garde seulement l'ID
      console.log("✅ ID sélectionné:", selected.idtres);
    } else {
      setIdTresseuse(""); // si pas trouvé
    }
  };
  /*
  const onCodeChange = async (e) => {
    setCode(e.target.value);

    try {
      const res = await fetch(
        `http://localhost:8000/api/search_tresseuse/${codenum}`
      );
      const data = await res.json();
      setResultats(data);
    } catch (err) {
      console.error(err);
    }
  };  */

  return (
    <div style={styles.pageBackground}>
      {/* Bandeau défilant */}
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            🌸 WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716 🌸
          </span>
        </marquee>
      </div>

      <div className="container-fluid py-1">
        <div className="row justify-content-center">
          <div className="col-11 col-md-11 col-lg-10">
            <div style={styles.card}>
              {/* Logo */}
              <div className="text-center mb-4">
                <img
                  src={require("../../assets/images/logo_fenasu.png")}
                  alt="logo"
                  style={{ width: "180px" }}
                />
                <h2>WORK TRAKING</h2>
              </div>

              {/* Formulaire */}
              <form>
                <div className="row g-4 align-items-end mb-4">
                  <div className="col-md-5">
                    <label className="form-label fw-bold fs-5">
                      Enter your Names or Code
                    </label>
                    <input
                      type="text"
                      list="groupDatalist"
                      className="form-control form-control-lg"
                      placeholder="Enter your name or code"
                      value={codenum}
                      onChange={(e) => setCode(e.target.value)}
                      onSelect={handleSelect}
                    />
                    <datalist id="groupDatalist">
                      {(Array.isArray(tresseuseSearch)
                        ? tresseuseSearch
                        : []
                      ).map((tres) => (
                        <option
                          key={tres.idtres}
                          value={`${tres.nomtres} (${tres.idtres})`}
                        />
                      ))}
                    </datalist>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label fw-bold fs-5">From</label>
                    <input
                      type="date"
                      className="form-control form-control-lg"
                      value={datdu}
                      onChange={(e) => setDatdu(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="form-label fw-bold fs-5">To</label>
                    <input
                      type="date"
                      className="form-control form-control-lg"
                      value={datau}
                      onChange={(e) => setDatau(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3 text-center">
                    <button
                      className="btn fw-bold shadow-sm"
                      style={styles.viewButton}
                      onClick={() => handleSearchwork()}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Chargement...
                        </>
                      ) : (
                        "🔍 View"
                      )}
                    </button>
                  </div>
                </div>

                {/* Montant total */}
                <div className="mb-4">
                  <label className="fw-bold fs-5">Total Amount</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={totamount}
                    readOnly
                  />
                </div>

                {/* Tableau */}
                <div className="table-responsive mt-4">
                  {/* ✅ SPINNEUR central pendant chargement */}
                  {loading && (
                    <div className="text-center my-4">
                      <div
                        className="spinner-border text-primary"
                        style={{ width: "4rem", height: "4rem" }}
                        role="status"
                      ></div>
                      <p className="mt-3 fw-bold">Loading data...</p>
                    </div>
                  )}

                  {/* Message d’erreur */}
                  {error && <div className="alert alert-danger">{error}</div>}

                  {/* Tableau de résultats */}
                  <div className="table-responsive mt-4">
                    {!loading && resultats.length > 0 && (
                      <table
                        className="table table-hover text-center align-middle w-100"
                        style={{
                          fontSize: "1.3rem",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          minWidth: "600px", // largeur minimale si le contenu est large
                        }}
                      >
                        <thead
                          style={{
                            background:
                              "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
                            color: "white",
                            fontSize: "1.2rem",
                          }}
                        >
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Service description</th>
                            <th>Amount received</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultats.map((r, i) => (
                            <tr
                              key={i}
                              style={{
                                backgroundColor:
                                  i % 2 === 0 ? "#f9f9f9" : "#e0f7fa",
                              }}
                            >
                              <td
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {r.id}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {r.date}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                - Client name: {r.nomclt} <br />- Service:{" "}
                                {r.nomtypt} <br />- Service amount:{" "}
                                {formatDollar(r.prix_final)} <br />- Cost of
                                hair extensions: {formatDollar(r.prix_mech)}{" "}
                                <br />- Cost of washing:{" "}
                                {formatDollar(r.prix_wash)}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {formatDollar(r.somme_mtpaie)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* 🎨 Styles */
const styles = {
  pageBackground: {
    minHeight: "100vh",
    background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "12px 0",
    borderBottom: "3px solid #fff",
  },
  marqueeText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  card: {
    background: "#fff",
    borderRadius: "15px",
    padding: "50px 40px",
    minHeight: "85vh",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease-in-out",
  },
  viewButton: {
    background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
    color: "white",
    border: "none",
    fontSize: "1.2rem",
    borderRadius: "10px",
    width: "160px",
    height: "50px",
    transition: "0.3s",
  },
  table: {
    fontSize: "1.2rem",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },
  tableHead: {
    background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
    color: "white",
    fontSize: "1.4rem",
  },
};

export default Empwork;
